<template>
  <teleport to="body">
    <transition leave-active-class="duration-200">
      <div
        v-show="show"
        class="fixed inset-0 overflow-y-auto px-4 py-6 sm:px-0 z-50"
        scroll-region
      >
        <transition
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="show"
            class="fixed inset-0 transform transition-all"
            @click="close"
          >
            <div class="absolute inset-0 bg-gray-500 opacity-75" />
          </div>
        </transition>

        <transition
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            v-show="show"
            class="overflow-y-visible shadow-xl transform transition-all max-sm:w-full sm:mx-auto"
            :class="size"
          >
            <header class="bg-indigo-200 px-5 py-8">
              <h3 class="text-font-darkest text-lg font-semibold">
                {{ title }}
              </h3>
              <p class="text-font-dark text-sm">
                {{ subtitle }}
              </p>

              <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <button
                  type="button"
                  class="text-font-darker hover:text-font-darkest focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                  @click="close"
                >
                  <span class="sr-only">Close</span>
                  <!-- Heroicon name: outline/x -->
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </header>
            <main class="bg-white p-5">
              <slot />
            </main>
            <footer v-if="footer" class="bg-white p-3 flex justify-end border-t border-font-lighter">
              <slot name="footer" />
            </footer>
          </div>
        </transition>
      </div>
    </transition>
  </teleport>
</template>

<script setup>

import { onMounted, onUnmounted } from 'vue';

onMounted(() => document.addEventListener('keydown', closeOnEscape));
onUnmounted(() => document.removeEventListener('keydown', closeOnEscape));

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
    default: false,
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: true,
  },
    size: {
      type: String,
        default: 'max-w-3xl'
    },
    footer: {
      type: Boolean,
        default: true
    }
});

const emit = defineEmits({ close: (_value) => true });

const closeOnEscape = (e) => {
  if (e.key === 'Escape' && props.show) {
    close();
  }
};

const close = () => {
  emit('close');
};

</script>
